import {shuffle} from "html-living-framework/lib/Utils/ArrayUtils";
import {IPoint} from "../core/Geom";
import {Signal} from "../core/Signal";
import {AnyStoryOptionModel, AnyStorySceneModel} from "../data/StoryModel";
import {GameManager} from "../managers/GameManager";
import {AbstractStoryScene} from "./AbstractStoryScene";
import {Focusables} from "./Focusables";
import {OptionButton} from "./OptionButton";

export class StorySceneOptions extends AbstractStoryScene {

    public readonly onSelect = Signal<(option: AnyStoryOptionModel) => void>();

    constructor(scene: AnyStorySceneModel, size: IPoint) {
        super();

        const options = scene.options;
        const buttons = options.map((option, index) => this.addChild(new OptionButton(scene, option, index, () => {
            this.onSelect(option);
        })));

        let n = 3;
        if (buttons.length <= n) {
            this.alignRow(buttons, 100);
        } else {
            n = 2;
            let y = -100;
            for (let i = 0; i < buttons.length; i += n) {
                this.alignRow(buttons.slice(i, i + n), y);
                y += 300;
            }
        }

        Focusables.add(...buttons);

        this.caption.text = this.getSceneCaption(scene, true);
        this.setCaptionPosition(size);
        this.caption.backgroundVisible = false;
    }

    public destroy(): void {
        this.onSelect.remove();
        super.destroy();
    }

    private alignRow(buttons: OptionButton[], y: number) {
        for (let i = 0; i < buttons.length; i++) {
            const button = buttons[i];
            button.x = (i - (buttons.length < 3 ? 0.5 : 1)) * (button.bodyWidth * 1.04);
            button.y = y;
        }
    }

    private getSecondItemOptions(options: AnyStoryOptionModel[]) {
        const selected = GameManager.instance.getSelectedOption("handItem");
        options = options.filter((it) => selected !== it.optionId);
        shuffle(options);
        return options.slice(0, 2);
    }
}
